// extracted by mini-css-extract-plugin
export var animStat = "FlyoverMapStats-module__animStat___nT0FR";
export var animStatsContainer = "FlyoverMapStats-module__animStatsContainer___Bi1fj";
export var stat = "FlyoverMapStats-module__stat___CP_vn";
export var statTitle = "FlyoverMapStats-module__statTitle___V1nTK";